/* jshint esversion: 6 */

/**
 * Service class to manage the structure of sheets and related modal windows.
 */
class SheetStructureHelperService {
    /**
     * Constructs the SheetStructureHelperService.
     * @param {Object} $uibModal - Angular UI Bootstrap modal service.
     * @param {Object} $signals - Signal service for emitting events.
     * @param {Object} $interval - Angular interval service.
     * @param {Object} $injector - Angular injector service.
     */
    constructor($uibModal, $signals, $interval, $injector) {
        this.$uibModal = $uibModal;
        this.$signals = $signals;
        this.$interval = $interval;
        this.$injector = $injector;
        this._deactiveCreateSheetModalBtn = false;
    }

    /**
     * Opens a modal window with the specified template and options.
     * @param {string} template - The template name for the modal.
     * @param {Object} sheet - The sheet object to be passed to the modal.
     * @param {Object} option - Additional options for the modal.
     * @returns {boolean} - Returns false if the template is undefined or falsy.
     */
    openModalWindow(template, sheet, option) {
        if (typeof template === "undefined" || !template) {
            return false;
        }

        if (!this._deactiveCreateSheetModalBtn) {
            this._deactiveCreateSheetModalBtn = true;

            var modalInstance = this.$uibModal.open({
                templateUrl: "/views/ib/cms/sheetStructure/" + template + "Modal.html",
                windowClass: "create-sheet",
                transclude: false,
                backdrop: 'static',
                keyboard: false,
                controller: 'SheetStructureEditorController',
                resolve: {
                    sheet: function () {
                        return sheet;
                    },
                    option: function () {
                        return option;
                    }
                }
            });
            modalInstance.result.then(function () {

            }, function () {
                this._deactiveCreateSheetModalBtn = false;
                this.$signals.emit("reload_sheets");

                if (option.updateQuestionPartlist) {
                    this.$signals.emit("update_question_part_list");
                }
            }.bind(this));
        }
    }

    /**
     * Opens a new sheet modal with the specified template and options.
     * @param {string} template - The template name for the modal.
     * @param {Object} option - Additional options for the modal.
     */
    openNewSheetModal(template, option) {
        var _options = {
            step: 1
        };
        if (typeof option !== "undefined" && option !== null) {
            _options = angular.extend(_options, option);
        }
        this.openModalWindow(template, undefined, _options);
    }

    /**
     * Opens an edit sheet modal with the specified template, sheet, and options.
     * @param {string} template - The template name for the modal.
     * @param {Object} sheet - The sheet object to be edited.
     * @param {Object} option - Additional options for the modal.
     */
    openEditSheetModal(template, sheet, option) {
        if (typeof sheet !== "undefined" && sheet !== null && sheet !== "") {
            var _options = {
                step: 2
            };
            if (typeof option !== "undefined" && option !== null) {
                _options = angular.extend(_options, option);
            }
            this.openModalWindow(template, sheet, _options);
        }
    }

    /**
     * Opens an edit question parts modal with the specified template, sheet, and options.
     * @param {string} template - The template name for the modal.
     * @param {Object} sheet - The sheet object containing the question parts.
     * @param {Object} option - Additional options for the modal.
     */
    openEditQuestionPartsModal(template, sheet, option) {
        if (typeof sheet !== "undefined" && sheet !== null && sheet !== "") {
            var _options = {
                step: 2,
                onlyStep: 2,
                updateQuestionPartlist: true
            };
            if (typeof option !== "undefined" && option !== null) {
                _options = angular.extend(_options, option);
            }
            this.openModalWindow(template, sheet, _options);
        }
    }

    /**
     * Opens a delete sheet modal for the specified sheet.
     * @param {Object} sheet - The sheet object to be deleted.
     */
    openDeleteSheetModal(sheet) {
        if (!this._deactiveCreateSheetModalBtn) {
            this._deactiveCreateSheetModalBtn = true;

            var modalInstance = this.$uibModal.open({
                templateUrl: "/views/ib/cms/sheetStructure/deleteSheetModal.html",
                windowClass: "delete-sheet",
                transclude: false,
                backdrop: 'static',
                keyboard: false,
                controller: 'DeleteSheetController',
                resolve: {
                    sheet: function () {
                        return sheet;
                    }
                }
            });
            modalInstance.result.then(function () {

            }, function () {
                this._deactiveCreateSheetModalBtn = false;
            }.bind(this));
        }
    }

    /**
     * Moves the specified sheet up in the list.
     * @param {Object} task - The task object containing the sheets.
     * @param {Object} sheet - The sheet object to be moved.
     * @param {number} index - The current index of the sheet.
     * @returns {boolean} - Returns false if the sheet is already at the top.
     */
    sheetUp(task, sheet, index) {
        if (index === 0) {
            return false;
        }

        var _at = 500;
        var newIndex = index - 1;
        var oldPos = angular.copy($(".overview-box-" + index).offset().top);
        var newPos = angular.copy($(".overview-box-" + newIndex).offset().top);

        $(".overview-box-" + index).css({
            position: "relative",
            zIndex: 1001,
            height: $(".overview-box-" + index).height()
        }).animate({
            top: (newPos - oldPos) / 2,
            width: $(".overview-box-" + index).width() + 100,
            left: '-50px'
        }, _at, function () {
            $(".overview-box-" + index).animate({
                top: (newPos - oldPos),
                width: $(".overview-box-" + index).width() - 100,
                left: '0'
            }, _at, function () {
                $(".overview-box-" + index).removeAttr("style");
                var clone = angular.copy(sheet.getUUID());
                task.data.sheets.splice(index, 1);
                task.data.sheets.splice(newIndex, 0, clone);
                task.flagAsDirty();
                this.$signals.emit("reload_sheets");
            }.bind(this));
        }.bind(this));

        $(".overview-box-" + newIndex).css({
            position: "relative",
            zIndex: 1000,
        }).animate({
            top: (oldPos - newPos) / 2,
            width: $(".overview-box-" + newIndex).width() - 100,
            left: '50px'
        }, _at, function () {
            $(".overview-box-" + newIndex).animate({
                top: (oldPos - newPos),
                width: $(".overview-box-" + newIndex).width() + 100,
                left: '0'
            }, _at, function () {
                $(".overview-box-" + newIndex).removeAttr("style");
            });
        });
    }

    /**
     * Moves the specified sheet down in the list.
     * @param {Object} task - The task object containing the sheets.
     * @param {Object} sheet - The sheet object to be moved.
     * @param {number} index - The current index of the sheet.
     * @returns {boolean} - Returns false if the sheet is already at the bottom.
     */
    sheetDown(task, sheet, index) {
        if (index === task.getSheetsWithoutPreReleaseAndJournal().length - 1) {
            return false;
        }

        var _at = 500;
        var newIndex = index + 1;
        var oldPos = angular.copy($(".overview-box-" + index).offset().top) - 50;
        var newPos = angular.copy($(".overview-box-" + newIndex).offset().top) - 50;

        $(".overview-box-" + index).css({
            position: "relative",
            zIndex: 1001
        }).animate({
            top: (newPos - oldPos) / 2,
            width: $(".overview-box-" + index).width() + 100,
            left: '-50px'
        }, _at, function () {
            $(".overview-box-" + index).animate({
                top: (newPos - oldPos),
                width: $(".overview-box-" + index).width() - 100,
                left: '0'
            }, _at, function () {
                $(".overview-box-" + index).removeAttr("style");
                var clone = angular.copy(sheet.getUUID());
                task.data.sheets.splice(index, 1);
                task.data.sheets.splice(newIndex, 0, clone);
                task.flagAsDirty();
                this.$signals.emit("reload_sheets");
            }.bind(this));
        }.bind(this));

        $(".overview-box-" + newIndex).css({
            position: "relative",
            height: $(".overview-box-" + newIndex).height(),
            zIndex: 1000
        }).animate({
            top: (oldPos - newPos) / 2,
            width: $(".overview-box-" + newIndex).width() - 100,
            left: '50px'
        }, _at, function () {
            $(".overview-box-" + newIndex).animate({
                top: oldPos - newPos,
                width: $(".overview-box-" + newIndex).width() + 100,
                left: '0'
            }, _at, function () {
                $(".overview-box-" + newIndex).removeAttr("style");
            });
        });
    }

    /**
     * Returns the sortable options for the task.
     * @param {Object} task - The task object containing the sheets.
     * @returns {Object} - The sortable options.
     */
    getSortableOptions(task) {
        if (!task) {
            var TaskDataService = this.$injector.get('TaskDataService'),
                TaskSelectionService = this.$injector.get('TaskSelectionService'),
                taskContext = TaskDataService.fetchContext(),
                taskUUID = TaskSelectionService.getTaskUUID(),
                currentTask = taskContext.read(taskUUID);
            task = currentTask;
        }
        return {
            placeholder: "overview-sortable-placeholder",
            axis: "y",
            containment: 'parent',
            scrollSensitivity: 190,
            cursor: "move",
            zIndex: 1020,
            revert: 100,
            tolerance: "pointer",
            start: function (event, ui) {
                ui.item.addClass('sortable-item');
                ui.placeholder.height(ui.helper.height() - 6);
                ui.item.oldPos = ui.placeholder.index();
            },
            change: function (event, ui) {
                ui.item.newPos = ui.placeholder.index();
            },
            stop: function (event, ui) {
                ui.item.removeClass('sortable-item');

                if (ui.item.newPos && ui.item.oldPos !== ui.item.newPos) {
                    var clone = angular.copy(task.data.sheets[ui.item.oldPos - 1]);
                    task.data.sheets.splice(ui.item.newPos - 1, 0, task.data.sheets.splice(ui.item.oldPos - 1, 1)[0]);
                    task.flagAsDirty();
                }
            }
        };
    }
}

export default SheetStructureHelperService;